import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 11.333c0 .368.298.667.667.667h10.666a.667.667 0 0 0 0-1.333H2.667a.667.667 0 0 0-.667.666M2 8c0 .368.298.667.667.667h10.666a.667.667 0 1 0 0-1.334H2.667A.667.667 0 0 0 2 8m.667-4a.667.667 0 0 0 0 1.333h10.666a.667.667 0 1 0 0-1.333z"
    }, null, -1)
  ])))
}
export default { render: render }